// GA4 Event Tracking
jQuery(function($) {
    // Track navigation menu clicks
    $('.menu a, .mobile-menu a, .ttr-site-footer a').on('click', function(e) {

        const linkText = $(this).text().trim();
        const linkUrl = $(this).attr('href');

        // alert(linkUrl);

        // Push to dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'navigation_click',
            'link_text': linkText,
            'link_url': linkUrl,
        });
    });
});
